<template>
  <div>{{ data.createdAt.split('T')[0] }}</div>
</template>

<script>
export default {
  props: ['data'],
}
</script>

<style></style>
